export default __webpack_public_path__ + "static/media/13M.c1ba3c16.jpeg";